import React from 'react';
import { isChunkLoadError, normalizeAppError } from './appRuntime';

const lazyRetryState = new Map();

export const lazyWithRetry = (factory, options = {}) => {
  const key = String(options.key || 'lazy-route');
  const retries = Number.isFinite(Number(options.retries))
    ? Math.max(0, Number(options.retries))
    : 1;

  return React.lazy(async () => {
    const currentAttempts = lazyRetryState.get(key) || 0;

    try {
      const module = await factory();
      lazyRetryState.delete(key);
      return module;
    } catch (error) {
      if (isChunkLoadError(error) && currentAttempts < retries) {
        lazyRetryState.set(key, currentAttempts + 1);
        return factory();
      }
      lazyRetryState.delete(key);
      throw normalizeAppError(error, {
        stage: 'lazy_route',
        scope: key,
      });
    }
  });
};
